module.exports = __webpack_public_path__ + "img/customerBindHandSuccess.9b6f41b5.png";